export default __webpack_public_path__ + "static/media/470.d335a2eb.png";